import { IconSearchLg } from "@pentabd/icons";
import { InputText } from "@pentabd/ui";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface SearchControllerProps {
  control: any;
  name: string;
  placeholder?: any;
  onChange: (value: string) => void;
  value?: string;
}

export default function SearchController({
  control,
  name,
  placeholder,
  onChange,
  ...props
}: SearchControllerProps) {
  const { t } = useTranslation();
  return (
    <Controller
      name={name}
      control={control}
      render={() => (
        <InputText
          key={name}
          name={name}
          outline
          placeholder={
            placeholder
              ? placeholder
              : t("PROCUREMENT_COMMITTEE_TABLE.TABLE.SEARCH")
          }
          prefix={<IconSearchLg height="20" width="20" />}
          size="sm"
          type="text"
          onChange={(e) => {
            onChange(e.target.value);
          }}
          controlling
          {...props}
        />
      )}
    />
  );
}
